import { sessionUtil } from '../utils/sessionUtil'

export const loadPinmap = (useCheckout) => {
  try {
    const { getCheckoutVariant, persistCheckoutVariant } = sessionUtil()
    const checkoutVariant = getCheckoutVariant()
    if (checkoutVariant) return checkoutVariant === 'pinflag'
    if (Math.random() < useCheckout) {
      persistCheckoutVariant('pinflag')
      return true
    }
    persistCheckoutVariant('native')
    return false
  } catch (error) {
    console.error('Error al cargar el pinmap', error)
    return false
  }
}
